import { apiOrbitClient } from 'src/data/api/apiOrbitClient';
import {
  CreateBusinessUnitCommand,
  CreateBusinessUnitCommandInput,
  DeleteBusinessUnitCommand,
  DeleteBusinessUnitCommandInput,
  GetBusinessUnitByProgramCommand,
  GetBusinessUnitByProgramCommandInput,
  ListBusinessUnitsCommand,
  ListBusinessUnitsCommandInput,
  UpdateBusinessUnitCommand,
} from '@amzn/gbsa-orbit-typescript-client';
import { UpdateBusinessUnitCommandInput } from '@amzn/gbsa-orbit-typescript-client';

export const businessUnitService = {
  getAll: (data: ListBusinessUnitsCommandInput) => {
    return apiOrbitClient.send(new ListBusinessUnitsCommand(data));
  },

  get: (data: GetBusinessUnitByProgramCommandInput) => {
    return apiOrbitClient.send(new GetBusinessUnitByProgramCommand(data));
  },
  update: (data: UpdateBusinessUnitCommandInput) => {
    return apiOrbitClient.send(new UpdateBusinessUnitCommand(data));
  },

  delete: (data: DeleteBusinessUnitCommandInput) => {
    return apiOrbitClient.send(new DeleteBusinessUnitCommand(data));
  },

  create: (data: CreateBusinessUnitCommandInput) => {
    return apiOrbitClient.send(new CreateBusinessUnitCommand(data));
  },
};
